import React from "react";
import {
  DomainManagement, DomainSummary
} from "../modules/domains";

const DomainManagementPage = () => {
  return <DomainManagement />;
}

export { DomainSummary, DomainManagementPage };